module.exports = __webpack_public_path__ + "img/f1.6f224b97.jpg";